import escrowImg from '../../../assets/escrow_logo.png';
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_0.5fr_1fr_1fr] gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">AI</span>
              </div>
              <span className="text-white font-bold text-xl">
                AIKnow 라이브 클래스
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed max-w-md">
              초등학생을 위한 AI 라이브 체험놀이 플랫폼을 소개합니다.
            </p>
            <p className="text-gray-300 leading-relaxed max-w-md">
              AI 아바타 선생님과 함께라면 어렵게만 느껴졌던 AI가 쉽고 재미있게
              다가옵니다.
            </p>
            <p className="text-gray-300 leading-relaxed max-w-md">
              놀이처럼 즐기는 사이, 아이의 창의력이 쑥쑥 자라납니다!
            </p>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              우리 아이의 무한한 가능성, 지금 함께 키워보세요.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">빠른 링크</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  수업 소개
                </a>
              </li>
              <li>
                <a
                  href="#classes"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  인기 수업
                </a>
              </li>
              <li>
                <a
                  href="#teachers"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  선생님 소개
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  무료 체험
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  학습 가이드
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">문의하기</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  gotoaiknow@gmail.com
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <span className="text-sm text-gray-300">
                  경기도 광명시 소하로 190, 243
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  <a
                    href="http://pf.kakao.com/_xjDIdX"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    고객문의 카카오톡 오픈방
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">사업자 정보</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-building-4-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  사업자등록번호 : 712-25-02031
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-lightbulb-flash-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  특허번호 : 10-2026-0044979
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-file-list-3-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  통신판매업신고번호 : 제2026-경기광명-0346호
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-file-list-3-line text-blue-400"></i>
                <span className="text-sm text-gray-300">
                  상표출원번호 : 40-2026-0065432
                </span>
              </div>
              <div className="flex justify-center md:justify-end mt-2">
                <a
                  href="https://liveclass.aiknow.ai.kr/api/pdf/escrow_cert.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={escrowImg}
                    alt="구매안전서비스 이용 확인"
                    className="w-24"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 AIKnow 라이브 클래스. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <a
                href="/policy/terms"
                className="text-gray-400 hover:text-white transition-colors"
              >
                이용약관
              </a>
              <a
                href="/policy/privacy"
                className="text-gray-400 hover:text-white transition-colors"
              >
                개인정보처리방침
              </a>
              <a
                href="/policy/refund"
                className="text-gray-400 hover:text-white transition-colors"
              >
                취소 및 환불정책
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
